module.exports = __webpack_public_path__ + "static/media/checkmark.ea27b896.svg";